import React from "react"
import styled from "@emotion/styled"
import Journey from "../../images/background.svg"

const Outer = styled.section`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 160px 0;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 64px;
  row-gap: 128px;
  background-image: url(${Journey});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    background-size: cover;
    grid-template-columns: 1fr;
    @media (max-width: ${props => props.theme.breakpoints.md}) {
      gap: 32px;
    }
  }
`
const Card = styled.div`
  padding: 32px;
  border: 4px solid ${props => props.theme.shade[80]};
  border-radius: 16px;
  background: ${props => props.theme.shade[100]};
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    &:nth-of-type(even) {
      margin-top: 25%;
      margin-bottom: -25%;
    }
  }
`

export default function StepFeature() {
  return (
    <Outer>
      <Inner>
        <Card>
          <h2>Plan the research</h2>
          <p>
            From our first meeting, we will start to understand you, your needs
            and your sector. Then we will take time to produce a bespoke user
            testing plan and discussion guide designed to deliver deep and rich
            findings.
          </p>
        </Card>
        <Card>
          <h2>Recruit Participants</h2>
          <p>
            Based on your existing knowledge, data or personas, we will work
            with you to define the characteristics, attitudes, beliefs and prior
            experiences of your target users. We will carefully recruit your
            participants to reflect the criteria agreed.
          </p>
        </Card>
        <Card>
          <h2>Run the Testing</h2>
          <p>
            We will invite your participants to an individual, one-to-one video
            call, typically of about 1 hour. After an initial discussion to
            explore their relevant wants, needs and experiences, we will
            carefully brief real-world scenarios to simulate actual life as
            closely as possible. As participants undertake specific tasks, we
            will look, listen, probe and learn whilst recording the video, audio
            and screen capture.
          </p>
        </Card>
        <Card>
          <h2>Undertake the Analysis</h2>
          <p>
            Immediately after each session, we will upload the full video for
            you to watch as and when convenient to you. We will then set about
            re-watching and analysing the footage, rewinding, pausing and
            watching again to establish what is working well, what isn’t and to
            understand why this is the case.
          </p>
        </Card>
        <Card>
          <h2>Produce Your Report</h2>
          <p>
            Your report will explain each of our findings, along with
            recommendations detailing where and how to make design improvements
            that will optimise your user experience. Examples can include how to
            communicate better the proposition, where to address any questions
            and doubts that users have and how to remove any confusion,
            frustration or weakness from your journey.
          </p>
        </Card>
      </Inner>
    </Outer>
  )
}
